<template>
  <v-autocomplete
    :error-messages="validationMessage"
    :items="contextCountries"
    :label="contextLabel"
    v-model="contextModel"
    :rules="rules"
    :readonly="$store.state.Delegation.readonly === true"
  />
</template>

<script>
import Country from "../../staticData/CountryTypes";

export default {
  name: "CountrySelect",
  props: {
    readonly: {
      required: false,
      default: false
    },
    model: {
      required: true
    },
    validationMessage: {
      type: Array,
      default: function() {
        return [];
      }
    },
    label: {
      default: null
    },
    rules: {
      required: false,
      default: function() {
        return [];
      }
    }
  },
  data: () => ({
    countries: Country
  }),
  computed: {
    contextModel: {
      set: function(value) {
        this.$emit("update:model", value);
      },
      get: function() {
        return this.model;
      }
    },
    contextLabel() {
      if (this.label == null) {
        return this.$t("global.country");
      }
      return this.label;
    },
    contextCountries() {
      let countries = [];
      for (let country of this.countries) {
        countries.push({
          text: this.$i18n.locale === "pl" ? country.polish_name : country.english_name,
          value: country.symbol
        });
      }
      return countries;
    }
  }
};
</script>

<style scoped></style>
